import { useMemo } from "react";

import { useSearchParams } from "react-router";

import { useProvider } from "app/contexts/ProviderContext";
import { policyCollectionFilterElement } from "app/utils/filters";

export function usePolicyCollectionFilterElement() {
  const [searchParams] = useSearchParams({});
  const search = searchParams.get("search");

  const selectedProvider = useProvider();

  return useMemo(
    () => policyCollectionFilterElement(selectedProvider, search),
    [search, selectedProvider],
  );
}
